import { renderless, api } from "@opentiny/vue-renderless/image/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import ImageViewer from "@opentiny/vue-image-viewer";
import imageError from "@opentiny/vue-theme/images/image-error.jpg";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  components: {
    ImageViewer
  },
  emits: ["load", "error"],
  props: [].concat(props, ["src", "fit", "lazy", "scrollContainer", "previewSrcList", "zIndex", "showIndex", "showHover", "previewVisible", "round", "imageSize"]),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api,
      extendOptions: {
        images: {
          imageError
        }
      }
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    class: ["relative inline-block overflow-hidden w-full rounded", {
      "min-h-[18.75rem]": _vm.lazy
    }, {
      "rounded-full": _vm.round
    }],
    style: {
      "width": _vm.imageSize + "px",
      "height": _vm.imageSize + "px"
    }
  }, [_vm.state.loading ? _vm._t("placeholder", function() {
    return [_c("div", {
      staticClass: "w-full h-full"
    })];
  }) : _vm.state.error ? _vm._t("error", function() {
    return [_c("img", {
      staticClass: "w-full h-full flex justify-center items-center text-sm align-middle text-color-bg-3 bg-no-repeat bg-center",
      attrs: {
        "src": _vm.state.images.imageError,
        "alt": ""
      }
    })];
  }) : _c("img", _vm._b({
    class: ["align-top w-full h-full rounded cursor-pointer", {
      "relative left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 block": _vm.state.getAlignCenter
    }],
    style: _vm.state.getImageStyle,
    attrs: {
      "src": _vm.src
    },
    on: {
      "click": _vm.clickHandler
    }
  }, "img", _vm.$attrs, false)), _c("div", {
    class: ["inline-block w-full h-full hover:bg-color-text-disabled absolute top-0 left-0 cursor-pointer", _vm.showHover ? "block" : "hidden"]
  }), _vm.state.getPreview && _vm.state.showViewer ? _c("image-viewer", {
    attrs: {
      "z-index": _vm.zIndex,
      "on-close": _vm.closeViewer,
      "url-list": _vm.previewSrcList,
      "show-index": _vm.showIndex
    },
    on: {
      "delete": _vm.deleteHander
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
